import { inject, Injectable } from '@angular/core';
import { NumberService } from './number.service';

@Injectable({
  providedIn: 'root'
})
export class ConsolidatedSABAUDBUtilService {

  public numService = inject(NumberService);

  private romanNumber: Array<string> = ['I', 'II'];
  private romanIndex: string = "";
  private fundSourceIndex: string = "";

  public aIndex: number = 0;
  public bIndex: number = 1;
  public cIndex: number = 0;

  // constructor() { }

  showUACS(item: any) {
    const exclude = ['sub-total', 'total', 'grand total'];
    if (item.ac == null || item.uacs == null || item.uacs == "0000000000" || exclude.includes(item.part.toLowerCase())) {
      return "";
    }
    // if research services / extension
    if (["98", "99"].includes(item.uacs.substring(1, 3))) {
      if (item.uacs.length > 10) {
        return `${item.uacs.substring(0, 1)}${item.uacs.substring(5)}`;
      }
      return `${item.uacs.substring(0, 1)}000000000`;
    }
    return item.uacs;
  }

  indention(item: any) {
    let is_header = this.isHeader(item);
    if (item.uacs != null) {
      // if research services / extension
      if (["98", "99"].includes(item.uacs.substring(1, 3)) && item.uacs.length > 10) {
        return `pl-4`;
      }
      if (item.uacs.substring(3) != "0000000") {
        return `pl-2 ${is_header}`;
      }
    }
    return `${is_header}`;
  }

  isHeader(item: any) {
    const exclude = ["0000000", "9999999"];
    if (item.uacs == null || item.ac == null || exclude.includes(item.uacs.substring(3))) {
      return "strong";
    }
    return "";
  }

  thousandSeparator(n: string | number) {
    let val = this.numService.thousandSeparator(n);
    return (typeof val === "string") ? val : "";
  }

  getNumber(item: any) {
    if (item.uacs == null || item.ac == null || item.uacs.substring(3) == "0000000") {
      const index = this.aIndex;

      // I-1.1, I-1.2, II-1.1, II-1.2
      if (item.ac != null && item.uacs.substring(3) == "0000000") {
        this.cIndex++;
        return `${this.fundSourceIndex}.${this.cIndex}`;
      }

      // I-1, I-2, II-1, II-2
      if (item.uacs == '0000000000') {
        this.cIndex = 0;
        this.fundSourceIndex = `${this.romanIndex}-${this.bIndex}`;
        this.bIndex++;
        return `${this.fundSourceIndex}`;
      }

      // I, II
      if (item.f_code.substring(5) == "0000") {
        this.romanIndex = this.romanNumber[index];
        this.bIndex = 1;

        this.aIndex++;
        if (this.aIndex > 1) {
          this.aIndex = 0;
        }

        return `${this.romanIndex}.`;
      }

      if (item.f_code.substring(5) == "9999" && item.f_code != "999999999") {
        return `${this.romanIndex}.`;
      }
    }
    return "";
  }

}
